module.exports = __webpack_public_path__ + "static/media/hero_3.ef7198d0.png";